import React, { useState } from "react";
import "../styles/Videos.css";

// ✅ Import videos
import Video1 from "../Assets/Videos/VID_20231109_144925.mp4";
import Video2 from "../Assets/Videos/Official Video.mp4";
import Video3 from "../Assets/Videos/My Video.mp4";

// ✅ Import thumbnails (optional)
// import Thumb1 from "../Assets/Images/video1-thumbnail.jpg";
// import Thumb2 from "../Assets/Images/video2-thumbnail.jpg";
// import Thumb3 from "../Assets/Images/video3-thumbnail.jpg";

export default function Videos() {
  const videos = [
    {
      id: 1,
      title: "VID_20231109_144925",
      subtitle: "Documentary Footage",
      src: Video1,
      // poster: Thumb1,
    },
    {
      id: 2,
      title: "Official Video",
      subtitle: "Institute Promotional Film",
      src: Video2,
      // poster: Thumb2,
    },
    {
      id: 3,
      title: "My Video",
      subtitle: "Student Activity Highlight",
      src: Video3,
      // poster: Thumb3,
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="videos-section">
      <div className="videos-container">
        <h2 className="videos-title">Video Gallery</h2>

        <div className="videos-grid">
          {videos.map((vid, index) => (
            <div key={vid.id} className="video-card" onClick={() => openModal(index)} style={{ cursor: "pointer" }}>
              <div className="video-wrapper">
                <video
                  src={vid.src}
                  poster={vid.poster}
                  muted
                  autoPlay
                  loop
                  playsInline
                  className="video-player"
                />
              </div>
              <div className="video-info">
                <h3>{vid.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ Modal for Enlarged Video */}
      {isModalOpen && (
        <div className="video-modal">
          <button className="close-btn" onClick={closeModal}>✖</button>
          <button className="nav-btn left" onClick={goToPrevious}>◀</button>
          <video
            src={videos[currentIndex].src}

            controls
            autoPlay
            className="modal-video"
          />
          <button className="nav-btn right" onClick={goToNext}>▶</button> 
          
        </div>
      )}
    </section>
  );
}
